export const PAGE_PATH = '/popup-view';
